module.exports = __webpack_public_path__ + "static/qamarero_logo-aa8862825f5813727d7e5dc37f26b349.png";